import axiosClient from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchInventoryAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get('/api/v1/admin/inventory/get');
}

export async function fetchInventoryDetailsAPI(inventoryId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/admin/inventory/${inventoryId}`);
}

export async function addInventoryItemAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/admin/inventory`, data);
}

export async function updateInventoryItemAPI(data, inventoryId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/admin/inventory/update/${inventoryId}`, data);
}

export async function deleteInventoryItemAPI(inventoryId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/admin/inventory/${inventoryId}`);
}